import { render } from "./DashboardRede.vue?vue&type=template&id=3e73e9ae&scoped=true"
import script from "./DashboardRede.vue?vue&type=script&lang=js"
export * from "./DashboardRede.vue?vue&type=script&lang=js"

import "./DashboardRede.vue?vue&type=style&index=0&id=3e73e9ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e73e9ae"]])

export default __exports__